export default __webpack_public_path__ + "static/media/support-icon.71daa568.svg";